import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
function EmptyAvatar(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#A9B1B9' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M512 15.999c-273.793 0-496.001 222.208-496.001 496.001s222.209 496.001 496.001 496.001c273.792 0 496.001-222.209 496.001-496.001s-222.209-496.001-496.001-496.001zM512 164.8c82.337 0 148.8 66.463 148.8 148.8s-66.463 148.8-148.8 148.8c-82.337 0-148.8-66.463-148.8-148.8s66.463-148.8 148.8-148.8zM512 869.121c0 0-0.001 0-0.003 0-123.691 0-232.696-62.883-296.787-158.426l-0.813-1.286c1.488-98.704 198.4-152.768 297.601-152.768 98.704 0 296.113 54.064 297.601 152.768-64.902 96.828-173.907 159.712-297.599 159.712-0.001 0-0.001 0-0.003 0v0h0.001z"
  }));
}
export default EmptyAvatar;